import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  GA_CHAT_EVENTS,
  GA_UPLOAD_CHAT_EVENTS,
  GA_UPLOAD_EXPLAIN_CHAT_EVENTS,
} from 'modules/ga/generalEvents';
import { pushPopup } from 'modules/popup/actions';
import { POPUP } from 'utils/constants/popup';
import app from 'new-ui/app';
import messageChatIcon from 'assets/icons/leal_role_chat.png';
import { isMoreThan30DaysApart } from './functions';
import './chatButton.css';

const sendGAEvent = (event, description) => {
  app.sendGoogleAnalyticsEvent(event, description);
};

const handleGAOnView = (currentPopupType) => {
  switch (currentPopupType) {
    case POPUP.CHAT_UPLOAD:
      sendGAEvent(GA_UPLOAD_CHAT_EVENTS.UPLOAD_CHAT_VIEW_BY_USER, 'user views upload chat');
      break;
    case POPUP.CHAT_UPLOAD_EXPLAIN:
      sendGAEvent(GA_UPLOAD_EXPLAIN_CHAT_EVENTS.UPLOAD_EXPLAIN_CHAT_VIEW_BY_USER, 'user views explain chat');
      break;
    default:
      break;
  }
};

const handleGAOnClick = (currentPopupType) => {
  switch (currentPopupType) {
    case POPUP.CHAT_UPLOAD:
      sendGAEvent(GA_UPLOAD_CHAT_EVENTS.UPLOAD_CHAT_OPEN, 'user opened upload chat');
      break;
    case POPUP.CHAT_UPLOAD_EXPLAIN:
      sendGAEvent(GA_UPLOAD_EXPLAIN_CHAT_EVENTS.UPLOAD_EXPLAIN_CHAT_OPEN, 'user upload explain chat');
      break;
    default:
      sendGAEvent(GA_CHAT_EVENTS.PROFILE_CHAT_OPEN, `user opened chat (type: ${currentPopupType || 'default'})`);
      break;
  }
};

const updateChatInteractionConfig = async () => {
  if (!app?.coniguration?.userConfiguration) {
    return;
  }
  try {
    const now = Date.now();
    const lastInteraction = app.coniguration.userConfiguration.interaction_with_smart_chat ?? null;

    const appConfigurationDataToUpdate = {
      chat_return_user: isMoreThan30DaysApart(lastInteraction, now),
      interaction_with_smart_chat: now,
    };

    await app.updateUserConfiguration(appConfigurationDataToUpdate);
  } catch (error) {
    console.error('Error updating chat configuration:', error);
  }
};

export const ChatButton = ({
  text,
  popupType,
}) => {
  useEffect(() => {
    handleGAOnView(popupType);
  }, [popupType]);

  const handleClick = async () => {
    handleGAOnClick(popupType);
    if (popupType !== POPUP.CHAT_UPLOAD_EXPLAIN) {
      updateChatInteractionConfig();
    }
    // it is not possible to use useDispatch as in UploadForm the component is rendered out of store provider
    app.store.dispatch(pushPopup({
      type: popupType,
      data: { preventOverlayClose: true },
    }));
  };

  return (
    <div
      className="chat-button"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); }}
      aria-label={text}
    >
      <div className="chat-button-container">
        <div className="chat-button-icon">
          <img src={messageChatIcon} alt="" />
        </div>
        {text}
      </div>
    </div>
  );
};

ChatButton.propTypes = {
  text: PropTypes.string.isRequired,
  popupType: PropTypes.oneOf([
    POPUP.NBA_CHAT, POPUP.ASSISTANCE_CHAT, POPUP.CHAT_UPLOAD, POPUP.CHAT_UPLOAD_EXPLAIN,
  ]).isRequired,
};
